import React, { useState } from "react"
import { Link } from "gatsby"
import {
  Navbar as BNavbar,
  Nav,
  Container,
  NavDropdown,
  Badge,
} from "react-bootstrap"
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaShoppingCart,
} from "react-icons/fa"
import logo from "@src/assets/img/logo3.png"
import { useStore } from "@components/StoreContext"

const Navbar = ({ transparent }) => {
  const { state } = useStore()

  const [isTransparent, setTransparent] = useState(transparent)

  const cartIcon = () => {
    const amountOfItems = state?.items.length ?? 0

    return (
      <Nav.Link eventKey={7} as={Link} to="/checkout">
        <FaShoppingCart
          size="1.3em"
          className={`${isTransparent ? "text-light" : "text-dark "} pb-1`}
        />
        {amountOfItems > 0 && <Badge variant="powder">{amountOfItems}</Badge>}
      </Nav.Link>
    )
  }

  return (
    <BNavbar
      collapseOnSelect
      expand="lg"
      bg={isTransparent ? "none" : "lipstick"}
      variant={isTransparent ? "dark" : "light"}
      className={isTransparent && "position-absolute w-100 navbar-transparent"}
    >
      <Container>
        <BNavbar.Brand as={Link} to="/">
          <img src={logo} width="300" />
        </BNavbar.Brand>
        <div className="d-flex">
          <span className="d-lg-none">{cartIcon()}</span>

          <BNavbar.Toggle
            aria-controls="responsive-BNavbar-nav"
            className="toggler"
            onClick={() => transparent && setTransparent(!isTransparent)}
          >
            <div className="top-bar"></div>
            <div className="middle-bar"></div>
            <div className="bottom-bar"></div>
          </BNavbar.Toggle>
        </div>
        <BNavbar.Collapse id="responsive-BNavbar-nav">
          <Nav className="links ml-auto mr-3">
            <Nav.Link eventKey={1} as={Link} to="/">
              Home
            </Nav.Link>
            <Nav.Link eventKey={2} as={Link} to="/about">
              About
            </Nav.Link>

            <NavDropdown title="Services" id="basic-nav-dropdown">
              <NavDropdown.Item as={Link} to="/products?cat=coaching">
                Coaching
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/products?cat=course">
                Courses
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/products?cat=product">
                Products
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link eventKey={6} as={Link} to="/contact">
              Contact
            </Nav.Link>

            <span className="d-none d-lg-inline">{cartIcon()}</span>
            <Nav.Link
              className="pl-3 pl-lg-2 ml-lg-2 bg-powder text-white"
              eventKey={6}
              href="https://yoursessionwithfifi.setmore.com/"
              target="_blank"
            >
              Make an appointment
            </Nav.Link>
          </Nav>
          <Nav className="social-media">
            <Nav.Link
              href="https://www.facebook.com/coachfifza"
              target="_newTab"
            >
              <FaFacebook />
            </Nav.Link>
            <Nav.Link
              href="https://www.instagram.com/coachfifi10/"
              target="_newTab"
            >
              <FaInstagram />
            </Nav.Link>
            <Nav.Link
              href="https://www.youtube.com/channel/UCArpLGGdpYmgtA8hZ-8RD7A/featured"
              target="_newTab"
            >
              <FaYoutube />
            </Nav.Link>
          </Nav>
        </BNavbar.Collapse>
      </Container>
    </BNavbar>
  )
}

export default Navbar
